module.exports = "<span class=\"cell-content\" (click)=\"select.emit()\">\n  <span *ngIf=\"value\">{{ value }}</span>\n  <span class=\"next-value\" *ngIf=\"!value\">{{ nextValue }}</span>\n</span>\n"


//////////////////
// WEBPACK FOOTER
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/pages/home/mobx-tic-tac/tic-tac-toe/cell/cell.component.html
// module id = ../../../../../src/app/pages/home/mobx-tic-tac/tic-tac-toe/cell/cell.component.html
// module chunks = main